import axios from 'axios';
import moment from 'moment';
import uniqBy from 'lodash/uniqBy';

import feedCalls from 'helpers/api-calls/feed-calls';
import teamCalls from 'helpers/api-calls/team-calls';
import actions from './actions';
import constants from './constants';
import { GetLocationChannels, } from 'helpers/api-calls/user-calls';
import { appActions } from 'App/duck';
import { getUserId } from 'helpers/cookies';


const { params } = constants;

const fetchChatSessions = (channel_id) => (dispatch) => {
  dispatch(actions.requestChatFeed());

  return feedCalls.getChatSessions(params.getChatSessions()).then((response) => {
    const {
      data: { chat_sessions, meta },
    } = response;

    dispatch(
      actions.hydrateChatFeed({
        data: chat_sessions,
        total_pages: meta.pagination.total_pages,
      })
    );
    // dispatch(appActions.ResetNotifyNewPost(channel_id));
  });
};

const fetchChatMessages = (chatSessionId, pageNumber = 1) => (dispatch) => {
  dispatch(actions.requestChatMessages({ chatSessionId, pageNumber }));

  return feedCalls.getChatMessages(chatSessionId, params.getChatMessages(1)).then((response) => {
    const {
      data: { chat_messages, meta },
    } = response;

    dispatch(
      actions.hydrateChatMessages({
        data: chat_messages,
        total_pages: meta.pagination.total_pages,
        chatId: chatSessionId,
      })
    );

    // dispatch(appActions.ResetNotifyNewPost(channel_id));
  });
};

const fetchMoreChatMessages = (chatSessionId, page) => (dispatch) => {
  dispatch(actions.requestChatMessages({ chatId: chatSessionId, pageNumber: page }));

  return feedCalls
    .getChatMessages(chatSessionId, params.getChatMessages(page))
    .then((response) => {
      const {
        data: { chat_messages, meta },
      } = response;

      dispatch(actions.appendChatMessages({
        chatId: chatSessionId,
        messages: chat_messages,
      }));
    });
};

const createChatSession = (selectedUserId, currentUserId, locationId) => (dispatch) =>
  feedCalls.createChatSession(selectedUserId, currentUserId, locationId).then((response) => {
    console.log('createChatSession response', response);
    const newSession = response.data?.chat_session;
    if (newSession?.id) {
      dispatch(actions.appendChatFeed(newSession));
      dispatch(actions.updateActiveChatSession(newSession.id));
    }
  })
    .catch((error) => {
      console.error('Failed to create chat session', error);
    });


const createChatMessage = (chat_session_id, chatMessage) => (dispatch) =>
  feedCalls.createChatMessage(chat_session_id, chatMessage).then((response) => {
    dispatch(actions.appendChatMessage({
      chat_session_id,
      message: response.data.chat_message
    }));

    const lastContent = response?.data?.chat_message?.message_type === 'message_image'
      ? 'An image has been shared.'
      : response?.data?.chat_message?.message || '';

    const payload = {
      chat_session_id: chat_session_id,
      content: lastContent,
      updated_at: response.data.chat_message.created_at,
    }
    dispatch(actions.updateChatFeedLastContent(payload));
  });

const fetchOneChatMessage = (chatSessionId, chatMessageId) => (dispatch, getState) => {
  const state = getState();
  const chatSessions = state.chatFeedReducer?.chats?.data || [];
  console.log('fetchOneChatMessage: chatSessions', chatSessions);
  const sessionExists = chatSessions.some(session => session.id === chatSessionId);

  if (sessionExists) {
    feedCalls.getOneChatMessage(chatSessionId, chatMessageId).then((response) => {
      dispatch(actions.appendChatMessage({
        chat_session_id: chatSessionId,
        message: response.data.chat_message
      }));

      const lastContent = response?.data?.chat_message?.message_type === 'message_image'
        ? 'An image has been shared.'
        : response?.data?.chat_message?.message || '';

      const payload = {
        chat_session_id: chatSessionId,
        content: lastContent,
        updated_at: response.data.chat_message.created_at,
      }

      dispatch(actions.updateChatFeedLastContent(payload));
    }).catch((error) => {
      console.log(`fetchOneChatMessage failed. messageId: ${chatMessageId}`);
    });
  }
  else {
    feedCalls.getOneChatSession(chatSessionId, chatMessageId).then((response) => {
      dispatch(actions.appendChatFeed(response.data.chat_session));
    }).catch((error) => {
      console.log(`getOneChatSession failed. chatSessionId: ${chatSessionId}`);
    });
  }
};

const archiveChatSession = (chatSessionId) => (dispatch) => {
  return feedCalls.archiveChatSession(chatSessionId).then((response) => {
    dispatch(actions.removeChatFeed({ id: chatSessionId }));
  }).catch((error) => {
    const msg = `operation delete Chat Session error: ${error}`;
    console.log(msg);
  });
};

const deletePost = (postId, lastPost) => (dispatch) =>
  feedCalls
    .deletePost(postId)
    .then((response) => {
      dispatch(actions.updateActivePost({ id: 0, channel_name: '' }));
      dispatch(actions.deletePost(postId));
      dispatch(actions.clearActiveDelete());
      dispatch(actions.updateActiveSidePane(''));
    })
    .catch((error) => {
      const {
        response: { status },
      } = error;

      if (status === 404) {
        // Silently succeed deleting already deleted post
        dispatch(actions.updateActivePost({ id: 0, channel_name: '' }));
        dispatch(actions.deletePost(postId));
        dispatch(actions.clearActiveDelete());
        dispatch(actions.updateActiveSidePane(''));
      } else {
        dispatch(
          actions.updateActiveError({
            code: error.response.status,
            action: actions.deletePost.toString(),
          })
        );
      }
    });

const updateDeletePost = (postId) => (dispatch) => {
  //dispatch(actions.updateActivePost({id: 0, channel_name: ''}));
  dispatch(actions.deletePost(postId));
  dispatch(actions.clearActiveDelete());
  //dispatch(actions.updateActiveSidePane(''));
};

const leaveGroup = (channelId, users) => (dispatch) => {
  const userIds = users.map((user) => {
    return user.owner_id
  });
  const start = moment();
  dispatch(appActions.resetError(userIds[0]));
  return teamCalls.leaveChannel({ channel_id: channelId }).then((response) => {
    let payload = { id: channelId, userId: userIds[0] };
    if (users[0].is_admin) {
      dispatch(appActions.removeChannelIdFromManager(payload));
    } else {
      dispatch(appActions.removeChannelIdFromAssociate(payload));
    }
    dispatch(appActions.removeChannel({ id: channelId }));
    const end = moment();
    const diff = moment.duration(end.diff(start))
    const ms = parseInt(diff.asMilliseconds());
    const s = `Leave channel took ${ms} ms.`;
    console.log(s);
  }).catch((error) => {
    const msg = `Team operation leaveGroup for user ${userIds[0]} error: ${error}`;
    console.log(msg);
    //dispatch(appActions.setError(userIds[0]));
  });
};

export default {
  fetchChatSessions,
  fetchChatMessages,
  fetchMoreChatMessages,
  deletePost,
  updateDeletePost,
  archiveChatSession,
  createChatSession,
  createChatMessage,
  leaveGroup,
  fetchOneChatMessage,
};
